import { Button } from "../ui/button";

const LimiarScreen = ({ onStart }) => (
  <div className="min-h-screen bg-[#F5F2EB] flex items-center justify-center p-8">
    <div className="max-w-2xl rounded-2xl bg-white border p-10 text-center">
      <h1 className="font-serif text-4xl mb-4">Limiar</h1>
      <p className="text-[#4A5568] leading-7 mb-8">
        Este ambiente conduz seu raciocínio técnico sem substituir sua autonomia profissional.
      </p>
      <Button onClick={onStart}>Iniciar caso</Button>
    </div>
  </div>
);

export default LimiarScreen;
